import toast from "react-hot-toast";
import { SERVER_URL } from "../server_config";
import { fetchWithToken } from "../helpers/auth";
import { authApi } from "../services/auth_endpoints";

export const ONBOARDING_START = 'ONBOARDING_START';
export const ONBOARDING_NEXT_STEP = 'ONBOARDING_NEXT_STEP';
export const ONBOARDING_SKIP = 'ONBOARDING_SKIP';
export const ONBOARDING_COMPLETE = 'ONBOARDING_COMPLETE';
export const SET_ONBOARDING_STATUS = 'SET_ONBOARDING_STATUS';
export const RESET_ONBOARDING = 'RESET_ONBOARDING';

export const startOnboarding = () => ({
  type: ONBOARDING_START,
});

export const nextOnboardingStep = () => {
  return async (dispatch) => {
    dispatch({
      type: ONBOARDING_NEXT_STEP,
    });
  };
};

const skipOnboarding = () => ({
  type: ONBOARDING_SKIP,
});

export const completeOnboarding = () => ({
  type: ONBOARDING_COMPLETE,
});

export const finishOnboarding = () => {
  return async (dispatch, getState) => {
    try {
      const userId = authApi.endpoints.getCurrentUser.select()(getState())?.data?.id;
      const response = await fetchWithToken(`${SERVER_URL}/users/${userId}/onboarding_completed`, {method: 'POST'});
      if (!response.ok) {
        throw new Error('Nu s-a putut finaliza tutorialul');
      }
      dispatch(completeOnboarding());
      toast.success('Tutorialul a fost finalizat cu succes!');
    }
    catch (error) {
      toast.error('Nu s-a putut finaliza tutorialul. Te rugam sa incerci din nou.');
      return;
    }
    dispatch(completeOnboarding());
  };
};

export const resetOnboarding = () => ({
  type: RESET_ONBOARDING,
});

export const setOnboardingStatus = (onboardingCompleted) => ({
  type: SET_ONBOARDING_STATUS,
  payload: onboardingCompleted,
});
